export default __webpack_public_path__ + "static/media/c010-1.23dbc3bb.png";